<template>
    <div class="search-filter">
        <a href="#" :class="['filter-button', {focus, active}]" @click.prevent="toggleFocus">{{ title }}</a>
        
        <div v-if="focus" :class="`filter-box shadow column-${options.length}`">
            <div class="row">
                <div v-for="(column, index) in options" :key="index" :class="column.class || 'col'">
                    <h3 v-if="column.title">{{ column.title }}</h3>
                    
                    <ul class="list-unstyled options-list">
                        <li v-for="option in column.options" :key="option.title">
                            <Checkbox v-if="option.type == 'checkbox'" v-model="option.value" :name="option.name" :label="option.title" :subtitle="option.subtitle" />
                            <OptionalSelect v-if="option.type == 'optionalSelect'" v-model="option.value" :name="option.name" :label="option.title" :subtitle="option.subtitle" />
                        </li>
                    </ul>
                </div>
            </div>
            
            <hr>
            
            <div class="row align-items-center">
                <div class="col">
                    <a href="#" @click.prevent="clear" class="clear-button text-muted">Clear</a>
                </div>
                <div class="col text-right">
                    <a href="#" @click.prevent="save" class="save-button btn btn-primary">Save</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/eventBus'
import Checkbox from '@/components/form-controls/Checkbox'
import OptionalSelect from '@/components/form-controls/OptionalSelect'

export default {
    name: 'SearchFilter',
    components: {
        Checkbox,
        OptionalSelect,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            checked: false,
            focus: false,
        }
    },
    computed: {
        active() {
            return this.options.some(option => option.options.some(opt => (opt.value !== false && opt.value != -1)))
        },
    },
    methods: {
        toggleFocus() {
            if (this.focus) {
                this.close()
            } else {
                this.open()
            }
        },
        open() {
            EventBus.$emit('close-all-filter-buttons', this);
            this.focus = true
        },
        close(save = true) {
            if (save) {
                this.$emit('save-filters')
            }
            this.focus = false
        },
        save() {
            this.close()
        },
        clear() {
            this.options.forEach(option => option.options.forEach(opt => {
                if (opt.type == 'checkbox') {
                    opt.value = false
                } else if (opt.type == 'optionalSelect') {
                    opt.value = -1
                }
            }))
            this.close()
        },
    },
    created() {
        EventBus.$on('close-all-filter-buttons', vm => {
            if (vm._uid != this._uid) {
                this.close(false)
            }
        });
        
        EventBus.$on('clear-all-filters', () => {
            this.clear();
        });
    }
};
</script>

<style lang="scss">
.search-filter {
    position: relative;
    display: inline-block;
    
    .filter-button {
        display: inline-block;
        border: 1px solid $light-gray;
        border-radius: 4px;
        background: $almost-white;
        padding: 4px 12px;
        color: $almost-black;
        
        &:hover {
            text-decoration: none;
        }
        
        &.focus {
            background: $dark-gray;
            color: $almost-white;
        }
        
        &.active {
            background: $almost-black;
            color: $almost-white;
        }
    }
    
    .filter-box {
        position: absolute;
        z-index: 1000;
        background: $almost-white;
        padding: 15px;
        white-space: nowrap;
        top: calc(100% + 9px);
        left: 1px;
        border: 1px solid $lightest-gray;
        border-radius: 4px;
        
        .options-list {
            margin: 0;
        }
        
        &.column-1 {
            width: auto;
        }
        &.column-2 {
            width: 800px;
        }
    }
}
</style>